const textFieldSignUp = {
  name: 'Nombre Completo',
  email: 'Email',
  reason: 'Motivo del acceso'
};

export default textFieldSignUp;
